import { useState, Dispatch, SetStateAction } from 'react';

export default function useCheckbox<Option>(
  checkedByDefault?: Set<Option>,
): [
  Set<Option>,
  () => void,
  Dispatch<SetStateAction<Set<Option>>>,
  (id: Option) => void,
  (ids: Option[]) => void,
] {
  const [selected, setSelected] = useState<Set<Option>>(
    new Set(checkedByDefault),
  );

  function reset() {
    setSelected(new Set());
  }

  function toggle(id: Option) {
    if (selected.has(id)) selected.delete(id);
    else selected.add(id);
    setSelected(new Set(selected));
  }

  function handleMultiSelect(ids: Option[]) {
    setSelected(new Set(ids));
  }

  return [selected, reset, setSelected, toggle, handleMultiSelect];
}
